// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/notice-bar/style/index.less
// module id = 194
// module chunks = 0